<template>
    <div
        class="wide-header-search"
        data-voicetext="Поиск по сайту"
        :class="{ active: isActive }"
        v-click-outside="closeHandler"
    >
        <SearchIcon
            v-show="!isActive"
            class="search-icon"
            @click="$emit('active')"
        />
        <div v-show="isActive" class="search-main">
            <div class="searching-block">
                <input
                    ref="input"
                    class="searching-input"
                    placeholder="Поиск по сайту"
                    v-model="search"
                >
                <div class="searching-switcher" @click="showCategoriesHandler">
                    <div class="searching-switcher-label">
                        Выбрать раздел
                    </div>
                    <div class="searching-switcher-arrow" :class="{ open: showCategories }" />
                </div>
                <!-- <div
                    class="searching-close-button"
                    @click="closeHandler"
                >
                    Закрыть
                </div> -->

                <font-awesome-icon
                    class="searching-close-button"
                    @click="closeHandler"
                    icon="times"
                ></font-awesome-icon>
            </div>
            <div v-if="showContent" class="content">
                <SearchResults
                    :show-categories="showCategories"
                    :search="search"
                    @change="changeCategoriesHandler"
                    @clear="clearSearchHandler"
                    @navigate="closeHandler"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SearchIcon from "../../assets/images/icons/search.svg?inline";
import SearchResults from "./SearchResults";
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'searchReceived',
];

const actions = [
    'searchText',
    'clearSearch',
];

export default {
    name: "WideHeaderSearch",

    components: {
        SearchResults,
        SearchIcon,
    },

    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            search: '',
            showCategories: false,
            activeCategories: [],
        };
    },

    computed: {
        ...mapGetters(getters),

        showContent() {
            return this.showCategories || this.searchReceived;
        },
    },

    watch: {
        isActive(value) {
            if (value) {
                this.$nextTick(() => {
                    const input = this.$refs.input;
                    input && input.focus();
                });
            }
        },

        search(value) {
            this.searchHandler(value);
        },
    },

    methods: {
        ...mapActions(actions),

        searchHandler(str) {
            const value = str !== undefined ? str : this.search;

            if (!value || value.length < 3) {
                this.clearSearch();
                return;
            }

            this.searchText({ str: value, filters: this.getFilters() });
        },

        getFilters() {
            let filterString = '';
            if (this.activeCategories) {
                this.activeCategories.forEach(el => {
                    filterString += `&filter[index][]=${ el }`;
                });
            }
            return filterString;
        },

        changeCategoriesHandler(items) {
            this.activeCategories = items;
            this.searchHandler();
        },

        showCategoriesHandler() {
            this.showCategories = !this.showCategories;
        },

        closeHandler() {
            this.showCategories = false;
            this.clearSearchHandler();
            this.$emit('close');
        },

        clearSearchHandler() {
            this.search = '';
            this.activeCategories = [];
            this.clearSearch();
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../styles/rem";

    .wide-header-search {
        position: relative;
        font-family: 'Proxima Nova', sans-serif;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .search-main {
            position: relative;
            z-index: 2;
            background: var(--color-white);
        }

        &.active {
            width: 100%;
        }

        .search-icon {
            width: rem(24);
            height: rem(24);
            margin-left: auto;
            cursor: pointer;
            color: var(--color-primary);

            &:hover {
                color: var(--color-primary);
            }
        }

        .searching {
            &-block {
                display: flex;
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: center;
                padding: rem(12) 0;
                border-bottom: 1px solid #D2D5D9;
                width: rem(710);
            }

            &-input {
                flex: 1 1 auto;
                margin-right: rem(16);
                border: none;
                outline: none;
                font-family: 'Proxima Nova', sans-serif;
                font-size: rem(18);
                line-height: rem(26);
                color: var(--color-dark-text);

                &::placeholder {
                    color: #98A0A9;
                }
            }

            &-contorls-row, &-switcher {
                display: flex;
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: center;
            }

            &-switcher {
                cursor: pointer;
            }

            &-switcher-label {
                user-select: none;
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(24);
                color: var(--color-primary);

                &:hover {
                    color: var(--color-primary-light);
                }

            }

            &-switcher-arrow {
                width: rem(12);
                height: rem(6);
                margin-left: rem(10);
                background: url("../../assets/images/icons/down-arrow-blue.svg") no-repeat center/contain;
                transition: trasform 200ms;

                &.open {
                    transform: rotate(180deg);
                    transition: trasform 200ms;
                }
            }

            &-back-button {
                width: rem(10);
                height: rem(16);
                margin-right: rem(15);
                background: url("../../assets/images/icons/back-arrow-blue.svg") no-repeat center/contain;
                cursor: pointer;
            }

            &-close-button {
                display: block;
                margin-left: rem(30);
                font-size: rem(22);
                line-height: rem(22);
                color: #98A0A9;
                cursor: pointer;
                width: rem(24);
                height: rem(24);

                &:hover {
                    color: var(--color-dark-text);
                }

            }
        }

        .content {
            @include custom-scroll-bar;
            position: absolute;
            top: rem(58);
            left: 0;
            right: 0;
            overflow-y: auto;
            max-height: rem(527);
            padding: rem(24) rem(24) rem(40);
            border-radius: 0 0 rem(10) rem(10);
            background: var(--color-white);
            box-shadow: 0 rem(3) rem(16)  rgba(155, 161, 166, 0.24);
        }
    }
</style>
